import { State } from "../state/state";

// Convert server data to User Interface friendly data
export const fromServer = (data: State.DataServer): State.Data => {
  let date = new Date(data.unix * 1000);
  return {
    ...data,
    unix: `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`
  };
};

// Convert User Interface friendly data to server data
export const toServer = (data: State.Data): State.DataServer => {
  return {
    ...data,
    unix: Date.parse(data.unix) / 1000
  };
};
